'use client'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faBookmark } from '@fortawesome/pro-regular-svg-icons'
import { faBookmarkSlash, faSpinner } from '@fortawesome/pro-solid-svg-icons'
import { useTranslations } from 'next-intl'
import { useCallback, useMemo } from 'react'

import { Button } from '../teqplay-ui'

import type { TVesselJourneyResponse } from '@/api/v1/resources/vesselJourney'
import useSwitchBookmarks from '@/app/hooks/useSwitchBookmarks'

type TPropsVesselBookmarkButton = {
  vessel: TVesselJourneyResponse
}

function VesselBookmarkButton({ vessel }: TPropsVesselBookmarkButton) {
  const t = useTranslations()
  const { getIsVesselBookmarked, handleRemoveBookmark, addBookmarkNow, isBookmarkLoading } =
    useSwitchBookmarks()

  const isBookmarked = useMemo(() => {
    if (!vessel) return false
    return getIsVesselBookmarked(vessel.ship.imo)
  }, [vessel, getIsVesselBookmarked])

  const onToggleBookmark = useCallback(() => {
    if (!vessel) return

    if (isBookmarked) {
      handleRemoveBookmark(vessel)
    } else {
      addBookmarkNow(vessel)
    }
  }, [vessel, isBookmarked, handleRemoveBookmark, addBookmarkNow])

  return (
    <Button
      variant="brand-secondary"
      aria-pressed={isBookmarked}
      onClick={onToggleBookmark}
      disabled={isBookmarkLoading}
      className="follow-main-btn"
    >
      <FontAwesomeIcon
        icon={isBookmarkLoading ? faSpinner : isBookmarked ? faBookmarkSlash : faBookmark}
        spin={isBookmarkLoading}
      />
      {!isBookmarked ? <span>{t('common.follow')}</span> : <span>{t('common.following')}</span>}
    </Button>
  )
}

export default VesselBookmarkButton
